 <template>
            <div v-if="fieldType == 'date'" class="input-field">
              <label :for="name">{{displayName}}</label>
              <span class="required" v-if="requiredField">*</span>
              <datepicker :format="'dd/MM/yyyy'" :placeholder="placeholder" v-model="value"></datepicker>
            </div>
</template>
<script>
export default {
    name: 'Input',
    // To use props, they must be declared
    props: {
        fieldType:String,
        name: String,
        requiredField: Boolean,
        displayName: String,
        placeholder:String,
        value:String,
    }
}
</script>